module.exports = __webpack_public_path__ + "static/media/O1.da8ca7fa.svg";